import type { InputHTMLAttributes } from 'react'
import { forwardRef } from 'react'
import { cn } from '@jotta/utils/css'

export type TextInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type' | 'checked'
>

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  function Input(props, ref) {
    return (
      <input
        {...props}
        type="text"
        className={cn('input', props.className)}
        ref={ref}
      />
    )
  },
)
